
import { mapGetters } from "vuex";
import vClickOutside from "v-click-outside";
import Highlighter from "vue-highlight-words";
import { mdiCheck, mdiMenuDown } from "@mdi/js";
import UpdatesCard from "@/components/v2/updates-card/updates-card.vue";
import UpdatesFilters from "~/components/v2/updates-filters.vue";

export default {
  directives: {
    clickOutside: vClickOutside.directive,
  },

  components: {
    Highlighter,
    UpdatesCard,
    UpdatesFilters,
  },

  filters: {
    // TODO: display city name based on api
    returnCityForCode(code) {
      if (+code === 1) return "Dubai";
      else if (+code === 2) return "Abu Dhabi";
    },
  },

  data() {
    return {
      mdiCheck,
      mdiMenuDown,

      sendPMModalId: null,

      profileMenuId: null,
      selectedFilterName: "",
      selectedFilters: {
        // Content: '',
        // Gender: '',
        // Status: [],
        location: [],
      },
      loading: false,
      dateFormatOptions: {
        year: "numeric",
        month: "short",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
      },
      customDatesStartFilter: "disable-future",
      orderFilter: "",
      timerId: null,

      isFiltersOpen: false,

      showMobileBottomNav: false,
    };
  },

  async fetch({ store, params }) {
    console.log("params", params);

    const currentCity = store.getters["global/getCurrentCity"];
    await store.commit("updates/setCities", [currentCity.id]);
    await store.commit("updates/setFilters", {
      filterName: "profile_id",
      value: params.slug.split("-")[0],
    });
    await store.dispatch("updates/retrieveNews");
    await store.dispatch("updates/loadCityCodes");
  },

  head() {
    return {
      title:
        this.seoTexts?.title || `Emiratescort News and Updates | ${this.name}`,
      link: [
        {
          rel: "canonical",
          href: `${this.$config.baseUrlApp}/escorts-updates/${this.slug}`,
        },
      ],
      meta: [
        {
          hid: "description",
          name: "description",
          content: this.seoTexts?.description || "",
        },
        {
          hid: "og:description",
          name: "og:description",
          content: this.seoTexts?.description || "",
        },
        {
          hid: "og:title",
          name: "og:title",
          content: this.seoTexts?.title || "Emiratescort News and Updates",
        },
      ],
    };
  },

  computed: {
    ...mapGetters({
      discreetMode: "getDiscreetStatus",
      isMobile: "global/getMobileStatus",
      allNews: "updates/getAllNews",
      getNumeberNews: "updates/getNumeberNews",
      getLastPage: "updates/getLastPage",
      getNextPage: "updates/getNextPage",
      searchText: "updates/getSearchText",
      filtersList: "profiles/getFiltersList",
      currentCity: "global/getCurrentCity",
      seoTexts: "global/getSeoTexts",
    }),

    h1() {
      return this.seoTexts?.h1 || `${this.name}: profile history`;
    },

    name() {
      return this.allNews?.at(0)?.profile?.name || this.$t("news-and-updates");
    },

    groupedByDate() {
      const grouped = {};
      this.allNews.forEach((newsItem) => {
        if (!grouped[newsItem.date_of_creation]) {
          grouped[newsItem.date_of_creation] = [];
        }
        grouped[newsItem.date_of_creation].push(newsItem);
      });
      return grouped;
    },

    numberShownNews() {
      return this.allNews?.length || 0;
    },

    filterObj() {
      const districts =
        this.filtersList?.districts?.filter(
          (district) => district.city_id == this.currentCity.id
        ) || [];
      return {
        district: {
          items: districts,
          title: this.$t("area"),
        },
      };
    },

    percentage() {
      return (this.numberShownNews * 100) / this.getNumeberNews;
    },

    slug() {
      return this.$route.params.slug;
    },
  },

  beforeDestroy() {
    this.$store.commit("updates/resetFilters");
    window.removeEventListener("scroll", this.handleScroll);
  },

  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },

  methods: {
    async showMoreNews() {
      this.loading = true;
      await this.$store.dispatch("updates/retrieveNews", "next");
      this.loading = false;
    },

    setFilter(value) {
      // this.selectedFilters = value;
      this.$store.commit("updates/setDistricts", { district: value.district });
      this.$store.dispatch("updates/retrieveNews");
    },
    clickToMenu(id) {
      if (!this.profileMenuId || this.profileMenuId !== id) {
        this.profileMenuId = id;
      } else {
        this.profileMenuId = null;
      }
    },

    onClickOutside() {
      this.profileMenuId = null;
    },

    sendPM(id) {
      if (id) {
        this.sendPMModalId = id;
      } else {
        this.sendPMModalId = null;
      }

      this.profileMenuId = null;
    },

    modalSendMessage(id) {
      return this.sendPMModalId === id ? true : false;
    },

    async setDistricts(districts) {
      this.$store.commit("updates/setDistricts", { district: districts });
      this.timerDateId = setTimeout(() => {
        this.$store.dispatch("updates/retrieveNews");
      }, 1000);
    },

    async setDate(dates) {
      clearTimeout(this.timerDateId);

      this.$store.commit("updates/setDateFilter", dates);

      this.timerDateId = setTimeout(() => {
        this.$store.dispatch("updates/retrieveNews");
      }, 1000);
    },

    async setSearchFilter(key, value) {
      clearTimeout(this.timerId);

      this.$store.commit("updates/setSearchText", value);

      this.timerId = setTimeout(() => {
        this.$store.dispatch("updates/retrieveNews");
      }, 1000);
    },

    switchFilters() {
      this.isFiltersOpen = !this.isFiltersOpen;
    },

    /**
     * Display date in a readable format
     * @param {String} date
     *
     * @returns {String}
     *
     * @example
     * Added today, June 10, 2024
     * Added yesterday, June 9, 2024
     * Added on June 8, 2024
     * Added on ...
     */
    displayDate(date) {
      const today = new Date();
      const dateObj = new Date(date);
      const diff = today.getDate() - dateObj.getDate();
      if (diff === 0) {
        return this.$t("added-today");
      }
      if (diff === 1) {
        return this.$t("added-yesterday");
      }
      return this.$t("added-on", [
        dateObj.toLocaleDateString("en-US", {
          month: "long",
          day: "numeric",
          year: "numeric",
        }),
      ]);
    },

    handleScroll() {
      if (window.scrollY > 100) {
        this.showMobileBottomNav = true;
      } else {
        this.showMobileBottomNav = false;
      }
    },
  },
};
